import React from "react";
import {
  ModalBackButton,
  ModalContainer,
  ModalHeader,
  ModalText,
} from "src/core/common/components/modules/modal/modalComponents";
import {FormContainer} from "src/core/common/components/collections/form/forms";
import {PrimaryLoadingButton} from "src/core/common/components/elements/button/PrimaryButton";
import Modal from "src/core/common/components/modules/modal/Modal";
import useRouter from "src/core/common/hooks/useRouter";
import styled from "styled-components";

export default function ManualReviewModal({
  isOpen,
  onCloseHandler,
  onCompleteManualVerificationHandler,
}) {
  const router = useRouter();

  return (
    <Modal isOpen={isOpen} onRequestClose={onCloseHandler}>
      <ModalBackButton onClick={() => router.safeBack()} />
      <ModalContainer>
        <ModalHeader>Manual review required</ModalHeader>
        <CenterModalText>
          The content from your ID requires human intervention to be verified correctly.
          We will review it as soon as possible. We will let you know when this process is
          complete, and you can finish your purchase.
        </CenterModalText>
        <FormContainer>
          <PrimaryLoadingButton onClick={onCompleteManualVerificationHandler}>
            Ok, I understand
          </PrimaryLoadingButton>
        </FormContainer>
      </ModalContainer>
    </Modal>
  );
}

const CenterModalText = styled(ModalText)`
  text-align: center;
  margin-bottom: 50px;
`;
